// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"4d311937","453":"3154de31"}[chunkId] + ".chunk.js";
};